import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { FertilizerProductId } from 'services/fertilizerEvents/types';
import { makeSelectProductOrder } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
}

type Props = OwnProps;

export default function ProductOrderTableCell(
    props: Props
): React.ReactElement {
    const productOrder = useSelector((state: AppState) =>
        makeSelectProductOrder()(state, props)
    );

    return <TableCell>{productOrder}</TableCell>;
}
